import { produce, immerable } from "immer";
import { type VendorDataItem, type InputVendorDataItem } from "../../gql-generated";
export class VendorDataEntryModel {
    public [immerable] = true;
    public constructor(
        public index: number | null = null,
        public data: VendorDataItem,
        public isKeyValid: boolean = false,
        public isValueValid: boolean = false,
    ) {}

    public static toInputDataModel({ key, value }: VendorDataItem): InputVendorDataItem {
        return {
            key,
            value,
        };
    }

    public setKey(key: string, isValid: boolean) {
        return produce(this, (draft) => {
            draft.data.key = key;
            draft.isKeyValid = isValid;
        });
    }
    public setValue(value: string, isValid: boolean) {
        return produce(this, (draft) => {
            draft.data.value = value;
            draft.isValueValid = isValid;
        });
    }

    public get isValid() {
        return this.isKeyValid && this.isValueValid;
    }
}
